import {PropertyBase} from "./PropertyBase";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";
import * as React from "react";
import {IconData} from "PageBuilder/utils/Dialogs/IconDialog";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {IconDialog} from "PageBuilder/Dialogs/IconDialog";

export class IconStyleProperty extends PropertyBase{
    public label:string="Label";


    public SubRenderer(): React.ReactNode {
        let option:IconData= this.GetOptionValue();
        return (
            <div style={{display:'flex'}}>
                <div style={{width: 40,textAlign:'center',cursor:'pointer'}}>
                    <div style={{height: 40,paddingTop: 3}}>
                        <label htmlFor={'iconStyle1'} style={{fontWeight:'normal',fontSize: 26,verticalAlign: 'top',fontFamily:this.Options.IconData.Font }} dangerouslySetInnerHTML={{__html:this.Options.IconData.Value}}/>
                    </div>
                    <input id={'iconStyle1'}  name="iconStyle" type="radio" value="basic" onChange={e=>this.SetIconStyle('basic')}/>
                </div>
                <div style={{textAlign:'center',marginLeft: 15,width:40}}>
                    <div style={{position:'relative',width: 40,cursor:'pointer'}}>
                        <img style={{width:40,height:40}} src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwcHgiIGhlaWdodD0iMTAwcHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGZpbGw9ImJsYWNrIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI1MCIgIC8+PC9zdmc+"/>
                            <div style={{position:'absolute',top:3,left: 0,width:'100%',textAlign: 'center'}}>
                                <label htmlFor={'iconStyle2'} style={{fontWeight:'normal',fontSize:26,color:'white',width:30,height:30,verticalAlign:'top',fontFamily: (this.Options as any).IconData.Font}} dangerouslySetInnerHTML={{__html:this.Options.IconData.Value}}/>
                            </div>
                    </div>
                    <input id={'iconStyle2'}  name="iconStyle" type="radio" value="round" onChange={e=>this.SetIconStyle('round')}/>
                </div>
                <div style={{textAlign:'center',marginLeft: 15,width:40,height:40}}>
                    <div style={{position: 'relative',width: 40,height:40,cursor:'pointer'}}>
                        <img style={{width: 40,height:40,position:'absolute',top:0,left:0}} src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBoZWlnaHQ9IjEwMHB4IiBzdHJva2U9IiMwMDAwMDAiIGZpbGw9IiMwMDAwMDAiIHdpZHRoPSIxMDBweCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSI+PC9yZWN0Pjwvc3ZnPg=="/>
                            <div style={{position:'absolute',top:3,left:0,width:'100%',textAlign:'center'}}>
                                <label htmlFor={'iconStyle3'} style={{fontWeight:'normal', fontSize: 26,color:'white',width:30,height:30,verticalAlign:'top',fontFamily:this.Options.IconData.Font}} dangerouslySetInnerHTML={{__html:this.Options.IconData.Value}}/>
                            </div>
                    </div>
                    <input name="iconStyle" id={'iconStyle3'} type="radio" value="square" onChange={e=>this.SetIconStyle('square')}/>
                </div>
            </div>
        )
    }

    private SetIconStyle(style:string) {
        this.SetOptionValue(style);
    }

}